import React from 'react';
import styled from 'styled-components';

import { MSG_TYPE_ERROR } from '../../constants/messageTypes';

const Pixel = styled.div`
  width: 1px;
  height: 1px;
  background: transparent;
  position: absolute;
  top: 0;
  bottom: 0;
`;

const AnalyticsPixel = ({ type, id = 'id' }) => {
  const pixelClasses = ['analytics-pixel'];
  let pixelId = `gtm-${id}`;

  if (type === MSG_TYPE_ERROR) {
    pixelClasses.push('analytics-pixel-error');
    pixelId = `gtm-error-${id}`;
  }

  return <Pixel className="analytics-pixel" id={pixelId} />;
};

export default AnalyticsPixel;
